import api from '.';

interface ReloadUserProjectPositions {
  projectId: number;
}

export async function reloadUserProjectPositions(
  reloadUserProjectPositions: ReloadUserProjectPositions
) {
  const { data } = await api.post(
    '/user-project-positions/reload',
    reloadUserProjectPositions
  );

  return data;
}
